import * as cn from "./SpecialityApp.scss"

import * as React from "react"
import {ChangeEventHandler, FormEventHandler} from "react"
import {Preloader} from "../React/Preloader";

interface Speciality {
    id: number
}


interface SpecialityData {
    specialities: Speciality[]
}

enum SpecialityMode {
    List = 1,
    Add,
}

interface SpecialityState {
    mode: SpecialityMode
    data?: SpecialityData
    id?: number
    isLoading: boolean
}

interface SpecialityFormProps {
    onClose: () => void
    speciality?: Speciality
    submit: (speciality: Omit<Speciality, "id">) => Promise<void>
}

interface SpecialityFormState {
    speciality: Omit<Speciality, "id">
    isLoading: boolean
}

class SpecialityForm extends React.PureComponent<SpecialityFormProps, SpecialityFormState> {
    state: SpecialityFormState = {
        speciality: {},
        isLoading: false,
    }

    constructor(props) {
        super(props)

        if (props.speciality) {
            this.state = {
                isLoading: false,
                speciality: {
                    ...this.state.speciality,
                    ...(props.speciality || {}),
                },
            }
        }
    }

    submit: FormEventHandler<HTMLFormElement> = event => {
        event.preventDefault();

        console.log(this.state)

        const {
        } = this.state.speciality

        this.setState({isLoading: true})

        this.props.submit({
        })
            .then(data => {
                this.setState({ isLoading: false })
                console.log(data)
                //      window.location.reload()
            })
            .catch(e => {
                console.log(e)
                this.setState({ isLoading: false })
            })
    }

    render() {
        if (this.state.isLoading) {
            return <Preloader/>
        }

        return <form onSubmit={this.submit}>
            <div className="modal fade in" tabIndex={-1} role="dialog"
                 style={{display: 'block'}}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" onClick={this.props.onClose}>
                                <span aria-hidden="true">×</span><span className="sr-only">Закрыть</span>
                            </button>
                            <h4 className="modal-title">Добавить информацию о финансировании</h4>
                        </div>
                        <div className="modal-body">
                        </div>
                        <div className="modal-footer">
                            <div className="btn-group">
                                <button type="submit" name="submit" className="btn btn-primary" value=""><i
                                    className="fa fa-check fa-inverse"></i> Сохранить
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade in"/>
        </form>
    }
}

interface SpecialityListProps {
    specialities: Speciality[]
    edit: (id: number) => void
    delete: (id: number) => void
}

class SpecialityList extends React.PureComponent<SpecialityListProps> {
    render() {
        return (
            <table className={cn.list}>
                <thead>
                    <tr>
                        <th className={cn.listHeaderCell}>#</th>
                        <th className={cn.listHeaderCell}/>
                    </tr>
                </thead>
                <tbody>
                {this.props.specialities.map(speciality => {
                    return (
                        <tr key={speciality.id} className={cn.listRow}>
                            <td className={cn.listCell}>
                                <div className={cn.listLink} onClick={() => this.props.edit(speciality.id)}>{speciality.id}</div>
                            </td>
                            <td className={cn.listCell}>
                                <i className={cn.listLink + " fa fa-trash-o"} title="Удалить" onClick={() => this.props.delete(speciality.id)}/>
                            </td>
                        </tr>
                    )
                })}
                </tbody>
            </table>
        )
    }
}

export class SpecialityApp extends React.PureComponent<{}, SpecialityState> {
    state: SpecialityState = {
        mode: SpecialityMode.List,
        isLoading: true,
    }

    componentDidMount() {
       this.loadData()
    }

    loadData = () => {
        this.setState({isLoading: true})

        fetch("/speciality/data")
            .then(response => response.json())
            .then<SpecialityData>(data => data as any)
            .then(data=>{
                this.setState({data, isLoading: false})
            });
    }
    openAddForm = () => this.setState({
        mode: SpecialityMode.Add,
        id: undefined,
    })
    openEditForm = (id: number) => {
        this.setState({
            mode: SpecialityMode.Add,
            id,
        })
    }
    closeForm = () => this.setState({
        mode: SpecialityMode.List,
        id: undefined,
    })
    delete = (id: number) => {
        this.setState({isLoading: true})

        return fetch("/speciality/delete/" + id, {
            method: "post",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
        })
            .then(res => {
                console.log(res)
                if (res.ok) {
                    return res.json();
                }

                throw res.status
            })
            .then(data => {
                if (data.errors) {
                    this.setState({isLoading: false})

                    return data
                }
                this.closeForm()
                this.loadData()
            })
    }
    submit = (speciality: Omit<Speciality, "id" | "companyId">) => {
        return fetch("/speciality/edit" + (this.state.id ? "/" + this.state.id : ""), {
            method: "post",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(speciality)
        })
            .then(res => {
                console.log(res)
                if (res.ok) {
                    return res.json();
                }

                throw res.status
            })
            .then(data => {
                if (data.errors) {
                    return data
                }
                this.closeForm()
                this.loadData()
            })
    }

    render() {
        if (!this.state.data || this.state.isLoading) {
            return <Preloader/>
        }

        return <>
            <div className="btn-group">
                <button className="btn btn-primary" disabled={this.state.mode === SpecialityMode.Add} onClick={this.openAddForm}><i
                    className="fa fa-plus fa-inverse"></i> Добавить информацию о финансировании
                </button>
            </div>
            {this.state.data && (
                <SpecialityList
                    specialities={this.state.data.specialities}
                    edit={this.openEditForm}
                    delete={this.delete}
                />
            )}
            {this.state.mode === SpecialityMode.Add && (
                <SpecialityForm
                    onClose={this.closeForm}
                    submit={this.submit}
                    speciality={this.state.id ? this.state.data.specialities.find((speciality: Speciality) => speciality.id === this.state.id) : undefined}
                />
            )}
        </>
    }
}